import { faSortUp, faSortDown } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SafTableSortDirection } from "./SafTableSortDirection";
import style from "./SafTableSortIcons.module.scss";

const SafTableSortIcons = ({
  sortDirection
}: {
  sortDirection: SafTableSortDirection
}) => {

  const upIconMuted = () => {
    if (sortDirection === SafTableSortDirection.none) {
      return true;
    }
    if (sortDirection === SafTableSortDirection.desc) {
      return true;
    }
    return false;
  }

  const downIconMuted = () => {
    if (sortDirection === SafTableSortDirection.none) {
      return true;
    }
    if (sortDirection === SafTableSortDirection.asc) {
      return true;
    }
    return false;
  }

  return (
    <div className={style.safSortIcons}>
      <span className={`${style.safSortIconUp} ${upIconMuted() && 'text-muted'}`}>
        <FontAwesomeIcon icon={faSortUp} size="sm" />
      </span>
      <span className={`${style.safSortIconDown} ${downIconMuted() && 'text-muted'}`}>
        <FontAwesomeIcon icon={faSortDown} size="sm" />
      </span>
    </div>
  )
};

export default SafTableSortIcons;

